import React from "react";
import Countdown from "react-countdown";
import "./discount.scss";

const Discount = () => {
  return (
    <div className="section discount">
      <div className="container text-center">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12" data-aos="fade-up">
            <div className="discount-text">
              <h3>Special discount on all grocery products</h3>
              <p className="my-4">
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Saepe
                id iusto at minima beatae totam est nulla.
              </p>
              <h3>
                <Countdown date={Date.now() + 200000000} />
              </h3>
              <h3>
                <span>Days</span>:<span>hrs</span>:<span>min</span>:
                <span>sec</span>
              </h3>
              <button className="shop-btn">Buy now</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Discount;
